/**
 * Focus / scroll helpers for the public valuation multi-step form.
 * Focus only after explicit Next/Back transitions — never on initial mount.
 */

export function prefersReducedMotion(matchMediaApi = globalThis.matchMedia) {
  if (typeof matchMediaApi !== 'function') return false;
  try {
    return Boolean(matchMediaApi('(prefers-reduced-motion: reduce)')?.matches);
  } catch {
    return false;
  }
}

/**
 * Move keyboard focus to the step heading and ensure it is visible.
 * @returns {boolean} true when focus was applied
 */
export function focusValuationStepHeading(element, { reducedMotion = prefersReducedMotion() } = {}) {
  if (!element || typeof element.focus !== 'function') return false;
  element.focus({ preventScroll: true });
  if (typeof element.scrollIntoView === 'function') {
    element.scrollIntoView({
      block: 'start',
      behavior: reducedMotion ? 'auto' : 'smooth',
    });
  }
  return true;
}
